/*       */
import Immutable from 'app/utils/immutable/Immutable';
import { LOAD_ROLE_STARTED, LOAD_ROLE_OF } from 'store/actions/admin/userManagementAction';

export default (
    state = Immutable({
        rolesAreLoading: false,
        availableRoles: {},
    }),
    { type, payload, error }
) => {
    switch (type) {
        case LOAD_ROLE_STARTED:
            return Immutable({ ...state, rolesAreLoading: true });
        case LOAD_ROLE_OF:
            if (error) {
                return state;
            }
            return Immutable({
                ...state,
                rolesAreLoading: false,
                availableRoles: {
                    ...state.availableRoles,
                    [payload.employee]: (payload.data || []).map(element => ({
                        value: element.user_role,
                        label: element.user_role || 'No Result Found',
                    })),
                },
            });
        default:
    }
    return state;
};
